<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<template>
  <div v-if="crop_field">
    <h1 class="page-title">
      <i class="fa-solid fa-leaf"></i
      ><span class="space-icon"></span>
      {{ show_crop_field_name ? crop_field?.name : "Campo" }}
    </h1>
    <div class="panel">
      <div class="panel-body">
        <div class="divide-slate-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.crop_field.producer") }}
              </dt>
              <dd class="content-data">
                {{ crop_field?.producer?.fullname }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.crop_field.hectares") }}
              </dt>
              <dd class="content-data">
                {{ crop_field?.hectares }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.crop_field.square_meters") }}
              </dt>
              <dd class="content-data">
                {{ crop_field?.square_meters }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">{{ $t("model.crop_field.crop") }}:</dt>
              <dd class="content-data">{{ crop_field?.crop?.name }}</dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityControlCropFieldInfo",
  props: {
    crop_field: {
      type: Object,
      required: true
    },
    show_crop_field_name: {
      type: Boolean,
      default: false
    }
  }
};
</script>
